(ns fablo-offers.app.core
  (:require
   [fablo-offers.common.lib.i18n :as i18n]
   [fablo-offers.app.root-view :as rv]
   [rumext.alpha :as mf]
   [lambdaisland.glogi :as log]
   [lambdaisland.glogi.console :as glogi-adapter]
   [fablo-offers.config-static :as cs]
   [fablo-offers.common.tracking :as tracking]
   ["react-dom/client" :as react-dom]))

(def _root nil)

(defn mount-root
  []
  (i18n/refresh! {})
  (let [root-el (.getElementById js/document "app")
        root (react-dom/createRoot root-el)]
    (set! _root root)
    (.render root (mf/element rv/root-view))))

(defn start-app! []
  (when cs/DEBUG?
    (glogi-adapter/install!)
    (log/set-levels {:fablo-offers :debug}))
  (tracking/init-default-trackers!)
  #_(i18n/init!))

(defn init
  []
  (start-app!)
  (mount-root))

(defn ^:dev/after-load refresh []
  (.unmount _root)
  (mount-root))
